import React, { useEffect, useRef, useState } from 'react'
import './template-game-preview.styles.scss'
import { useLocation, useParams } from 'react-router-dom'
import { getGameDataFromDb, getGameElementsFromRtDb, getGameElementShortList } from '@/utils/getDataFromDb'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { off } from 'firebase/database'
import { properCase } from '@/utils/properCase'
import ElementPreviewItem from './element-preview-item.component'
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified'

const TemplateGamePreview = () => {

  const { templatePath } = useParams();
  const [gameData, setGameData] = useState(null);
  const [elementType, setElementType] = useState(null);
  const [gameElements, setGameElements] = useState([]);
  const [elementTypes, setElementTypes] = useState([]);
  const [teams, setTeams] = useState([]);
  const elementsRef = useRef({});
  const teamsRef = useRef();
  const location = useLocation();

  useEffect(() => {
    if (!templatePath || !location) return;
    getGameData();
  }, [templatePath, location])

  function getGameData() {
    let status = 'active';
    if (location.pathname.includes('/archive/')) {
      status = 'archived';
    }
    console.log(status, templatePath);
    getGameDataFromDb(
      {
        'gamePath': templatePath,
        'status': status,
        'callback': callback,
        'once': true
      }
    )
    function callback(data) {
      const gameData = Object.values(data)[0];
      console.log(gameData);
      setGameData(gameData);
      getGameElements(gameData);
      getTeams(gameData); 
    }
  }

  function getGameElements(data) {
    getGameElementShortList(
      {
        'gameId': data.gameId,
        'callback': callback,
        'once': true
      }
    )
    function callback(data) {
      elementsRef.current = {
        ...elementsRef.current,
        ...data
      }
      console.log('elementsRef', elementsRef.current);
      setGameElements(elementsRef.current);
      setElementTypes([...new Set(Object.values(elementsRef.current).map(el => el.type))]);
    }
  }

  function getTeams(data) {
    getQueryFromFirestore({
      'path': `games/${data.gameId}/players`,
      'queryArray': [
        {
          'field': 'team',
          'operator': '==',
          'value': true
        },
        {
          'field': 'status',
          'operator': '==',
          'value': 'active'
        }
      ],
      'callback': callback,
      'once': true
    })
    function callback(data) {
      console.log(data);
      const processedTeams = {};
      Object.values(data).forEach(team => {
        team.type = 'team';
        processedTeams[team.playerId] = team;
      })
      elementsRef.current = {
        ...elementsRef.current,
        ...processedTeams
      }
      console.log(elementsRef.current);
      setGameElements(elementsRef.current);
      setElementTypes([...new Set(Object.values(elementsRef.current).map(el => el.type))]);
    }
  }

  return (
    <div className='template-game-preview'>
      {
        (gameData)
          ?
          <div className='game-preview'>
            <ImageContainer
              src={gameData.header} />
            <h2>{gameData.gameName.replace(' [TEMPLATE]', '')}</h2>
            <div dangerouslySetInnerHTML={{ __html: gameData.desc }}></div>
            <div className="g-space-1"></div>
            <p><b>View Included Elements</b></p>
            <div className='game-preview-select'>
              <ImageContainer
                src={gameData.icon}
                className={'game-preview-icon'} />
              <div className='field small'>
                <select
                  value={elementType ?? ''}
                  onChange={(e) => setElementType(e.target.value)}>
                  <option value=''>Select Element Type</option>
                  {
                    (elementTypes) &&
                    elementTypes
                    .sort()
                    .map((el, index) => (
                      <option key={el} value={el}>{properCase(el)}s</option>
                    ))
                  }
                </select>
              </div>
            </div>
            {
              (elementType && gameElements) &&
              <div className='game-preview-elements'>
                {
                  Object.values(gameElements)
                    .filter(el => el.type === elementType)
                    .sort((a, b) => a.type === 'item' ? a.opt_itemType.localeCompare(b.opt_itemType) : 0)
                    .map((el, index) => (
                      <ElementPreviewItem
                        gameData={gameData}
                        key={el.id}
                        element={el} />
                    ))
                }
              </div>
            }
          </div>
          :
          <div className='loading'>
            <p>Loading game data...</p>
          </div>
      }

    </div>
  )
}

export default TemplateGamePreview